import React from 'react'
import ReactDropdown from 'react-dropdown'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight, faChevronUp } from '@fortawesome/free-solid-svg-icons'

export const Dropdown = ({ ...props }) => {
  // wl-select-option
  // wl-select-root
  // wl-select-control
  return (
    <ReactDropdown
      {...props}
      placeholder={null}
      baseClassName="wl-select"
      className="relative"
      controlClassName="relative overflow-hidden border border-gray-300 rounded-md p-2 flex justify-between items-center"
      placeholderClassName="text-2xl"
      menuClassName="-mt-1px absolute overflow-y-auto m-h-80 z-50 bg-white w-full border border-t-0 border-green-500 rounded-md rounded-t-none text-xl font-semibold"
      arrowClosed={<FontAwesomeIcon icon={faChevronRight} className="text-xl" />}
      arrowOpen={<FontAwesomeIcon icon={faChevronUp} className="text-xl" />}
    />
  )
}

export default Dropdown
